"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentFile = AttachmentFile;
exports.AttachmentPhoto = AttachmentPhoto;
exports.Header = Header;
exports.Layout = Layout;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _AttachmentIcon = _interopRequireDefault(require("../../components/AttachmentIcon"));
var _HorizontalList = _interopRequireDefault(require("../../components/HorizontalList"));
var _utils = require("../../utils");
var _filesize = _interopRequireDefault(require("filesize"));
var _excluded = ["children"],
  _excluded2 = ["name", "from", "contentType"],
  _excluded3 = ["thumbnail", "from", "name", "size", "contentType"];
function Header(_ref) {
  var onViewAll = _ref.onViewAll;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between pb-2"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "mb-3 text-xl font-semibold text-dark"
  }, t('contactDetail.attachments.title')), /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-xs font-semibold text-primary",
    onClick: onViewAll
  }, t('button.viewAll')));
}
var HEIGHT = 105;
var COLUMN_WIDTH = 380;
function Layout(_ref2) {
  var header = _ref2.header,
    children = _ref2.children;
  var count = _react["default"].Children.count(children);
  var nodes = _react["default"].Children.toArray(children);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-8"
  }, header, /*#__PURE__*/_react["default"].createElement(_HorizontalList["default"], {
    invert: false,
    count: count,
    height: HEIGHT,
    rowHeight: HEIGHT,
    columnWidth: COLUMN_WIDTH,
    cellRenderer: function cellRenderer(_ref3) {
      var key = _ref3.key,
        columnIndex = _ref3.columnIndex,
        style = _ref3.style;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: key,
        style: style
      }, nodes[columnIndex]);
    }
  }));
}
function AttachmentItemLayout(_ref4) {
  var children = _ref4.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full pb-3 mr-8"
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "h-full cursor-pointer bg-card",
    style: {
      boxShadow: '0px 5px 20px #0000000A'
    }
  }, rest), children));
}
function AttachmentFile(_ref5) {
  var name = _ref5.name,
    from = _ref5.from,
    contentType = _ref5.contentType,
    rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded2);
  var type = (0, _utils.getAttachmentType)(contentType, name);
  return /*#__PURE__*/_react["default"].createElement(AttachmentItemLayout, rest, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center w-full h-full p-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-5"
  }, /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    colored: true,
    contentType: contentType,
    fontSize: "large",
    fileName: name
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 text-xs"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold truncate text-dark"
  }, name), from && /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate text-medium"
  }, from), /*#__PURE__*/_react["default"].createElement("p", {
    className: "uppercase truncate text-medium"
  }, type))));
}
function AttachmentPhoto(_ref6) {
  var thumbnail = _ref6.thumbnail,
    from = _ref6.from,
    name = _ref6.name,
    size = _ref6.size,
    contentType = _ref6.contentType,
    rest = (0, _objectWithoutProperties2["default"])(_ref6, _excluded3);
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var thumbnailNode = (0, _utils.isImage)(contentType, name) ? thumbnail : /*#__PURE__*/_react["default"].createElement("img", {
    src: t('placeholder-photo.png'),
    alt: "Placeholder"
  });
  return /*#__PURE__*/_react["default"].createElement(AttachmentItemLayout, rest, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center w-full h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full recommendation-photo-thumbnail"
  }, thumbnailNode), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 p-5 text-xs"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate font-bold text-dark"
  }, name), /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate text-medium"
  }, (0, _filesize["default"])(size)))));
}
//# sourceMappingURL=Attachments.js.map